import type { ListColumn } from '../lists/ColumnsPicker.tsx';

export const CAMPAIGN_COLUMNS = [
  { id: 'type', label: 'Campaign type' },
  { id: 'channels', label: 'Channels' },
  { id: 'schedule', label: 'Entry schedule' },
  { id: 'stopDate', label: 'Stop date' },
  { id: 'sent', label: 'Sent' },
  { id: 'tags', label: 'Tags' },
  { id: 'updated', label: 'Last edited' },
  { id: 'createdBy', label: 'Created by' },
] as const satisfies readonly ListColumn<string>[];
export type CampaignColumn = (typeof CAMPAIGN_COLUMNS)[number]['id'];
export const DEFAULT_CAMPAIGN_COLUMNS: CampaignColumn[] = ['type', 'sent', 'tags', 'updated'];
